import React from 'react';
import './userPhoto.css';
import { useDispatch, useSelector } from "react-redux";
import { watchPhotoAction } from "../../redux/rootReducer";
import { site } from "../../config";

const UserPhoto = () => {
    const dispatch = useDispatch();
    const watch_photo = useSelector(state => state.watch_photo);

    if (!watch_photo) return false;

    return (
        <div className="form">
            <div className="form__scrollable user_photo--scrollable">
                <div className="user_photo__wrapper">
                    <img alt={ 'Фото посетителя' } className="user_photo" src={ site + watch_photo } />
                    <i className="user_photo__close" onClick={ () => dispatch(watchPhotoAction('')) } />
                </div>
            </div>
        </div>
    );
};

export default UserPhoto;